import { createContext, useContext, useEffect, useState } from "react";
import * as en from "@/data/content";
import * as de from "@/data/content.de";
import { uiEn } from "@/data/ui.en";
import { uiDe } from "@/data/ui.de";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("site-lang") || "en");

  useEffect(() => {
    localStorage.setItem("site-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    c: lang === "de" ? de : en,
    ui: lang === "de" ? uiDe : uiEn,
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useContent = () => useContext(LangContext);
